<div class="grid-container">
  <div class="esf-accordion esf-accordion--info-tiles">
    <div app-accordion-table
         class="esf-accordion__unit esf-accordion--info-tiles"

         [accordionHeading]="tablesTranslations.i18nLastContacts"
         [isPanelOpened]="isPanelOpened"
         [actionButtonTooltip]="tooltipTranslations.i18nCreateNewContact"
         [actionButtonIcon]="'#esf-icon-circle-outlined-plus'"

         [emptyStateIcon]="'#esf-icon-conversation'"
         [emptyStateText]="tablesTranslations.i18nNoContacts"
         [emptyStateButtonText]="tablesTranslations.i18nAddNewContact"

         [showAllLink]="'contacts'"

         (actionButtonClickEvent)="createNewContact()"
         (rowClickEvent)="fillContact($event)"
         (panelTriggerClickEvent)="isPanelOpenedChange.emit(!isPanelOpened)"

         [data]="contacts"
         [keys]="keys"
         [columns]="columns">
    </div>
  </div>
</div>
